import { z } from 'zod'
import { FirestoreTimestamp } from './utils'

/**
 * Report Template Schema
 * Defines the structure and capabilities of a report template
 * Collection: /companies/{companyId}/reportTemplates/{templateId}
 */
export const ReportTemplate = z.object({
  id: z.string().min(1, 'Template ID is required'),
  name: z.string().min(1, 'Template name is required'),
  description: z.string().min(1, 'Template description is required'),
  version: z.string().min(1, 'Template version is required'),

  // Array of supported filter types (e.g., ['siteIds', 'mechanicIds', 'workRouteIds'])
  supportedFilters: z.array(z.string()).default([]),

  // Audit fields
  createdAt: FirestoreTimestamp,
  updatedAt: FirestoreTimestamp,
})

export type ReportTemplate = z.infer<typeof ReportTemplate>
